/* eslint-disable eqeqeq */
import {
  DeleteOutlined,
  DownloadOutlined,
  SearchOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Button,
  Input,
  InputNumber,
  Modal,
  Popconfirm,
  Select,
  Table,
  Tag,
  Upload,
  message,
} from "antd";
import React, { useState } from "react";
import { connect } from "react-redux";
import * as XLSX from "xlsx/xlsx.mjs";
import { Capitalize, ConvertDateTime } from "../helper";
import {
  CreateManufacturerQuote,
  DeleteManufacturerQuote,
  GetQuoteRequestsByRole,
  UpdateManufacturerQuote,
} from "../services/QuoteService.jsx";

const config = JSON.parse(localStorage.getItem("config") ?? "{}");
const moment = require("moment/min/moment-with-locales");
moment.locale("tr");

const QuoteModal = ({
  visible,
  onCancel,
  onSubmit,
  quoteRequest,
  isEdit,
  initialData,
}) => {
  const [formData, setFormData] = useState({
    vade: 90,
    deliveryDate: "",
    aciklama: "",
    fiyat: 0,
    kur: "₺",
    quoteFile: null,
  });
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);

  // initialData değiştiğinde form verilerini güncelle
  React.useEffect(() => {
    const loadFormData = async () => {
      if (initialData) {
        // ISO tarih formatını HTML date input için uygun formata çevir
        const formatDateForInput = (dateString) => {
          if (!dateString) return "";
          const date = new Date(dateString);
          // Timezone sorununu önlemek için yerel tarih bilgilerini kullan
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          return `${year}-${month}-${day}`;
        };

        // Mevcut dosya varsa blob'a çevir
        let existingFileBlob = null;
        console.log("Backend'den gelen quoteFile:", initialData.quoteFile);
        console.log("quoteFile tipi:", typeof initialData.quoteFile);
        console.log("quoteFile uzunluğu:", initialData.quoteFile?.length);
        console.log(
          "quoteFile ilk 100 karakter:",
          initialData.quoteFile?.substring(0, 100)
        );
        if (initialData.quoteFile) {
          try {
            // Eğer base64 string ise blob'a çevir
            if (
              typeof initialData.quoteFile === "string" &&
              initialData.quoteFile.startsWith("data:")
            ) {
              const response = await fetch(initialData.quoteFile);
              existingFileBlob = await response.blob();
            } else if (initialData.quoteFile instanceof Blob) {
              existingFileBlob = initialData.quoteFile;
            } else if (
              typeof initialData.quoteFile === "string" &&
              initialData.quoteFile.startsWith("http")
            ) {
              // Eğer URL ise fetch ile blob'a çevir
              const response = await fetch(initialData.quoteFile);
              existingFileBlob = await response.blob();
            } else if (Array.isArray(initialData.quoteFile)) {
              // Eğer byte array ise blob'a çevir
              existingFileBlob = new Blob([
                new Uint8Array(initialData.quoteFile),
              ]);
            } else if (typeof initialData.quoteFile === "string") {
              // Eğer sadece base64 string ise (data: prefix olmadan)
              try {
                const response = await fetch(
                  `data:application/octet-stream;base64,${initialData.quoteFile}`
                );
                existingFileBlob = await response.blob();
              } catch (error) {
                console.error("Base64 string'i blob'a çevirirken hata:", error);
              }
            }
          } catch (error) {
            console.error("Dosya yüklenirken hata:", error);
          }
        }

        console.log("existingFileBlob:", existingFileBlob);
        console.log("existingFileBlob tipi:", typeof existingFileBlob);

        setFormData({
          vade: initialData.vade || 90,
          deliveryDate: formatDateForInput(
            initialData.deliveryDate || initialData.delivery_date
          ),
          aciklama: initialData.aciklama || "",
          fiyat: initialData.fiyat || 0,
          kur: initialData.kur || "₺",
          quoteFile: existingFileBlob,
        });

        // Eğer mevcut dosya varsa fileList'i güncelle
        if (existingFileBlob) {
          setFileList([
            {
              uid: "-1",
              name: initialData.quoteFileName || "teklif_dosyasi",
              status: "done",
              originFileObj: existingFileBlob,
            },
          ]);
        } else {
          setFileList([]);
        }
      } else {
        setFormData({
          vade: 90,
          deliveryDate: "",
          aciklama: "",
          fiyat: 0,
          kur: "₺",
          quoteFile: null,
        });
        setFileList([]); // Clear fileList when no initialData
      }
    };

    loadFormData();
  }, [initialData]);

  // Dosya boyutunu kontrol et (4MB = 4 * 1024 * 1024 bytes)
  const beforeUpload = (file) => {
    const isLt4M = file.size / 1024 / 1024 < 4;
    if (!isLt4M) {
      message.error("Dosya boyutu 4MB'dan küçük olmalıdır!");
      return false;
    }
    return true;
  };

  // Dosyayı blob olarak işle
  const convertToBlob = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = () => {
        const blob = new Blob([reader.result], { type: file.type });
        resolve(blob);
      };
      reader.onerror = (error) => reject(error);
    });
  };

  // Dosya değişikliklerini handle et
  const handleFileChange = async (info) => {
    let newFileList = [...info.fileList];

    // Sadece son yüklenen dosyayı al
    newFileList = newFileList.slice(-1);

    // Dosya yüklendiyse blob olarak işle
    if (newFileList.length > 0 && newFileList[0].originFileObj) {
      try {
        const blob = await convertToBlob(newFileList[0].originFileObj);
        setFormData({ ...formData, quoteFile: blob });
        setFileList(newFileList);
      } catch (error) {
        message.error("Dosya yüklenirken hata oluştu!");
      }
    } else {
      setFileList(newFileList);
    }
  };

  // Dosyayı kaldır
  const handleRemoveFile = () => {
    setFormData({ ...formData, quoteFile: null });
    setFileList([]);
  };

  // Dosyayı indir
  const handleDownloadFile = () => {
    let fileToDownload = null;

    // Önce formData'dan, sonra fileList'ten dosyayı al
    if (formData.quoteFile) {
      fileToDownload = formData.quoteFile;
    } else if (fileList.length > 0 && fileList[0].originFileObj) {
      fileToDownload = fileList[0].originFileObj;
    }

    if (fileToDownload) {
      // Blob'dan URL oluştur
      const url = URL.createObjectURL(fileToDownload);
      const link = document.createElement("a");
      link.href = url;
      link.download = `teklif_dosyasi_${new Date().getTime()}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  };

  // Form validasyonu - buton disabled durumu için
  const isFormValid = () => {
    return formData.vade && formData.fiyat && formData.deliveryDate;
  };

  const handleSubmit = async () => {
    setLoading(true);

    // FormData oluştur (blob dosyası için)
    const submitFormData = new FormData();
    submitFormData.append("vade", formData.vade);
    submitFormData.append("deliveryDate", formData.deliveryDate);
    submitFormData.append("aciklama", formData.aciklama);
    submitFormData.append("fiyat", formData.fiyat);
    submitFormData.append("kur", formData.kur);
    submitFormData.append("quoteRequestId", quoteRequest.id);
    submitFormData.append(
      "createdBy",
      localStorage.getItem("username") || "unknown"
    );

    // Eğer dosya varsa blob olarak ekle
    if (formData.quoteFile) {
      submitFormData.append("quoteFile", formData.quoteFile, "quoteFile");
    }

    try {
      await onSubmit(submitFormData, isEdit ? initialData.id : null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={isEdit ? "Teklifi Düzenle" : "Teklif Ver"}
      open={visible}
      onCancel={onCancel}
      onOk={handleSubmit}
      okText={isEdit ? "Güncelle" : "Teklif Ver"}
      cancelText="İptal"
      width={600}
      confirmLoading={loading}
      okButtonProps={{ disabled: !isFormValid() }}
    >
      <div style={{ marginBottom: 16 }}>
        <label
          style={{ display: "block", marginBottom: 8, fontWeight: "bold" }}
        >
          Vade (Gün): <span style={{ color: "red" }}>*</span>
        </label>
        <InputNumber
          style={{ width: "100%" }}
          value={formData.vade}
          onChange={(value) => setFormData({ ...formData, vade: value })}
          min={1}
          placeholder="Vade günü"
        />
      </div>

      <div style={{ marginBottom: 16 }}>
        <label
          style={{ display: "block", marginBottom: 8, fontWeight: "bold" }}
        >
          Teslim Tarihi: <span style={{ color: "red" }}>*</span>
        </label>
        <Input
          style={{ width: "100%" }}
          type="date"
          value={formData.deliveryDate}
          onChange={(e) =>
            setFormData({ ...formData, deliveryDate: e.target.value })
          }
          placeholder="Teslim tarihi seçin"
        />
      </div>

      <div style={{ marginBottom: 16 }}>
        <label
          style={{ display: "block", marginBottom: 8, fontWeight: "bold" }}
        >
          Açıklama:
        </label>
        <Input.TextArea
          style={{ width: "100%" }}
          value={formData.aciklama}
          onChange={(e) =>
            setFormData({ ...formData, aciklama: e.target.value })
          }
          placeholder="Detaylı açıklama"
          rows={4}
        />
      </div>

      <div style={{ marginBottom: 16 }}>
        <label
          style={{ display: "block", marginBottom: 8, fontWeight: "bold" }}
        >
          Fiyat: <span style={{ color: "red" }}>*</span>
        </label>
        <InputNumber
          style={{ width: "100%" }}
          value={formData.fiyat}
          onChange={(value) => setFormData({ ...formData, fiyat: value })}
          min={0}
          step={0.01}
          placeholder="Fiyat"
        />
      </div>

      <div style={{ marginBottom: 16 }}>
        <label
          style={{ display: "block", marginBottom: 8, fontWeight: "bold" }}
        >
          Kur:
        </label>
        <Select
          style={{ width: "100%" }}
          value={formData.kur}
          onChange={(value) => setFormData({ ...formData, kur: value })}
        >
          <Select.Option value="₺">TL</Select.Option>
          <Select.Option value="$">USD</Select.Option>
          <Select.Option value="€">EUR</Select.Option>
        </Select>
      </div>

      <div style={{ marginBottom: 16 }}>
        <label
          style={{ display: "block", marginBottom: 8, fontWeight: "bold" }}
        >
          Teklif Dosyası (Maksimum 4MB):
        </label>
        <Upload
          beforeUpload={beforeUpload}
          onChange={handleFileChange}
          fileList={fileList}
          onRemove={handleRemoveFile}
          maxCount={1}
          accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
        >
          <Button icon={<UploadOutlined />}>Dosya Seç</Button>
        </Upload>
        {(formData.quoteFile || fileList.length > 0) && (
          <div
            style={{
              marginTop: 8,
              display: "flex",
              alignItems: "center",
              gap: 8,
              flexWrap: "wrap",
            }}
          >
            {isEdit && (formData.quoteFile || fileList.length > 0) && (
              <Button
                type="link"
                size="small"
                icon={<DownloadOutlined />}
                onClick={handleDownloadFile}
                style={{ color: "#1890ff" }}
              >
                İndir
              </Button>
            )}
            <Button
              type="link"
              danger
              size="small"
              icon={<DeleteOutlined />}
              onClick={handleRemoveFile}
            >
              Kaldır
            </Button>
          </div>
        )}
      </div>
    </Modal>
  );
};

const QuoteDetailsModal = ({ visible, onCancel, quoteData }) => {
  return (
    <Modal
      title="Verilen Teklif Detayları"
      open={visible}
      onCancel={onCancel}
      footer={[
        <Button key="close" onClick={onCancel}>
          Kapat
        </Button>,
      ]}
      width={600}
    >
      <div style={{ marginBottom: 16 }}>
        <label
          style={{ display: "block", marginBottom: 8, fontWeight: "bold" }}
        >
          Vade (Gün):
        </label>
        <div
          style={{
            padding: "8px 12px",
            border: "1px solid #d9d9d9",
            borderRadius: "6px",
            backgroundColor: "#fafafa",
          }}
        >
          {quoteData?.vade || "-"}
        </div>
      </div>

      <div style={{ marginBottom: 16 }}>
        <label
          style={{ display: "block", marginBottom: 8, fontWeight: "bold" }}
        >
          Teslim Tarihi:
        </label>
        <div
          style={{
            padding: "8px 12px",
            border: "1px solid #d9d9d9",
            borderRadius: "6px",
            backgroundColor: "#fafafa",
          }}
        >
          {quoteData?.deliveryDate
            ? ConvertDateTime(quoteData.deliveryDate)
            : "-"}
        </div>
      </div>

      <div style={{ marginBottom: 16 }}>
        <label
          style={{ display: "block", marginBottom: 8, fontWeight: "bold" }}
        >
          Açıklama:
        </label>
        <div
          style={{
            padding: "8px 12px",
            border: "1px solid #d9d9d9",
            borderRadius: "6px",
            backgroundColor: "#fafafa",
            minHeight: "80px",
          }}
        >
          {quoteData?.aciklama || "-"}
        </div>
      </div>

      <div style={{ marginBottom: 16 }}>
        <label
          style={{ display: "block", marginBottom: 8, fontWeight: "bold" }}
        >
          Fiyat:
        </label>
        <div
          style={{
            padding: "8px 12px",
            border: "1px solid #d9d9d9",
            borderRadius: "6px",
            backgroundColor: "#fafafa",
          }}
        >
          {quoteData?.fiyat
            ? `${quoteData.fiyat} ${quoteData.kur || "₺"}`
            : "-"}
        </div>
      </div>

      <div style={{ marginBottom: 16 }}>
        <label
          style={{ display: "block", marginBottom: 8, fontWeight: "bold" }}
        >
          Oluşturulma Tarihi:
        </label>
        <div
          style={{
            padding: "8px 12px",
            border: "1px solid #d9d9d9",
            borderRadius: "6px",
            backgroundColor: "#fafafa",
          }}
        >
          {quoteData?.createdDate
            ? ConvertDateTime(quoteData.createdDate)
            : "-"}
        </div>
      </div>

      <div style={{ marginBottom: 16 }}>
        <label
          style={{ display: "block", marginBottom: 8, fontWeight: "bold" }}
        >
          Teklif Dosyası:
        </label>
        <div
          style={{
            padding: "8px 12px",
            border: "1px solid #d9d9d9",
            borderRadius: "6px",
            backgroundColor: "#fafafa",
          }}
        >
          {quoteData?.quoteFile ? (
            <div>
              <span style={{ color: "#52c41a" }}>✓ Dosya yüklendi</span>
              <br />
              <small style={{ color: "#666" }}>
                Dosya boyutu:{" "}
                {quoteData.quoteFile.size
                  ? (quoteData.quoteFile.size / 1024 / 1024).toFixed(2) + " MB"
                  : "Bilinmiyor"}
              </small>
            </div>
          ) : (
            "-"
          )}
        </div>
      </div>
    </Modal>
  );
};

class ProducerQuotesScreen extends React.Component {
  configFile = JSON.parse(localStorage.getItem("config") ?? "{}");

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{
            width: 188,
            marginBottom: 8,
            display: "block",
          }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Bul
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Sıfırla
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        type="search"
        style={{ color: filtered ? "#1890ff" : undefined }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ?.toString()
        ?.toLowerCase()
        ?.includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => text,
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "orange";
      case "approved":
        return "blue";
      case "rejected":
        return "red";
      case "completed":
        return "green";
      default:
        return "blue";
    }
  };

  getStatusText = (status) => {
    switch (status) {
      case "pending":
        return "Beklemede";
      case "approved":
        return "Onaylandı";
      case "rejected":
        return "Reddedildi";
      case "completed":
        return "Tamamlandı";
      default:
        return status;
    }
  };

  state = {
    csvdata: [
      [
        "İş Emri No",
        "Ürün Adı",
        "Açıklama",
        "Miktar",
        "Birim",
        "Durum",
        "Oluşturulma Tarihi",
        "Notlar",
      ],
    ],
    loading: false,
    data: [],
    quoteModalVisible: false,
    selectedQuoteRequest: null,
    isEditMode: false,
    editQuoteData: null,
    quoteDetailsModalVisible: false,
    selectedQuoteDetails: null,
    columns: [
      {
        title: "İş Emri No",
        dataIndex: "genericTaskId",
        sorter: (a, b) => (a.genericTaskId || 0) - (b.genericTaskId || 0),
        ...this.getColumnSearchProps("genericTaskId"),
        render: (text) => <td>{text || "-"}</td>,
      },
      {
        title: "Ürün Adı",
        dataIndex: "productName",
        sorter: (a, b) => a.productName.localeCompare(b.productName),
        ...this.getColumnSearchProps("productName"),
        render: (text) => <td>{Capitalize(text)}</td>,
      },
      {
        title: "Açıklama",
        dataIndex: "description",
        sorter: (a, b) => a.description.localeCompare(b.description),
        ...this.getColumnSearchProps("description"),
        render: (text) => <td>{text ? Capitalize(text) : ""}</td>,
      },
      {
        title: "Miktar",
        dataIndex: "quantity",
        sorter: (a, b) => a.quantity - b.quantity,
      },
      {
        title: "Birim",
        dataIndex: "unit",
        sorter: (a, b) => a.unit.localeCompare(b.unit),
        ...this.getColumnSearchProps("unit"),
      },
      {
        title: "Durum",
        dataIndex: "status",
        sorter: (a, b) => a.status.localeCompare(b.status),
        render: (text, record) => (
          <td>
            {record.hasUserQuote ? (
              <Tag color="green">Teklif Verildi</Tag>
            ) : (
              <Tag color={this.getStatusColor(text)}>
                {this.getStatusText(text)}
              </Tag>
            )}
          </td>
        ),
      },
      {
        title: "Oluşturulma Tarihi",
        dataIndex: "createdDate",
        sorter: (a, b) =>
          moment(a.createdDate).unix() - moment(b.createdDate).unix(),
        ...this.getColumnSearchProps("createdDate"),
        render: (text) => <td>{ConvertDateTime(text)}</td>,
      },
      {
        title: "İşlemler",
        render: (text, quoteRequest) => (
          <td>
            {!quoteRequest.hasUserQuote ? (
              <Button
                style={{ margin: 5 }}
                block
                size="large"
                type="primary"
                onClick={() => {
                  this.setState({
                    quoteModalVisible: true,
                    selectedQuoteRequest: quoteRequest,
                    isEditMode: false,
                    editQuoteData: null,
                  });
                }}
              >
                Teklif Ver
              </Button>
            ) : quoteRequest.status === "completed" ? (
              <Button
                style={{ margin: 5 }}
                block
                size="large"
                type="default"
                onClick={() => {
                  this.setState({
                    quoteDetailsModalVisible: true,
                    selectedQuoteDetails: quoteRequest.userQuote,
                  });
                }}
              >
                Verilen Teklifi Gör
              </Button>
            ) : (
              <>
                <Button
                  style={{ margin: 5 }}
                  block
                  size="large"
                  type="default"
                  onClick={() => {
                    this.setState({
                      quoteModalVisible: true,
                      selectedQuoteRequest: quoteRequest,
                      isEditMode: true,
                      editQuoteData: quoteRequest.userQuote,
                    });
                  }}
                >
                  Teklifi Düzenle
                </Button>
                <Popconfirm
                  title="Bu teklifi silmek istediğinizden emin misiniz?"
                  onConfirm={() => {
                    DeleteManufacturerQuote(quoteRequest.userQuote.id).then(
                      (res) => {
                        if (res) this.GetQuoteRequests();
                      }
                    );
                  }}
                  okText="Evet"
                  cancelText="Hayır"
                >
                  <Button
                    style={{ margin: 5 }}
                    block
                    danger
                    size="large"
                    type="primary"
                  >
                    Teklifi Sil
                  </Button>
                </Popconfirm>
              </>
            )}
          </td>
        ),
      },
    ],
  };

  componentDidMount() {
    this.GetQuoteRequests();
  }

  componentWillReceiveProps = (newProps, oldProps) => {
    setTimeout(() => {
      this.GetQuoteRequests();
    }, 500);
  };

  GetQuoteRequests() {
    this.setState({ loading: true });
    let csvdata = [
      [
        "İş Emri No",
        "Ürün Adı",
        "Açıklama",
        "Miktar",
        "Birim",
        "Durum",
        "Oluşturulma Tarihi",
        "Notlar",
      ],
    ];

    GetQuoteRequestsByRole().then((data) => {
      // Kullanıcının rolüne göre filtrele
      const filteredData = data?.filter((quoteRequest) => {
        if (!Array.isArray(quoteRequest.targets)) return false;
        return quoteRequest.targets.includes(this.props.user.role);
      });

      filteredData?.forEach((quoteRequest) => {
        quoteRequest.targetRoles = Array.isArray(quoteRequest.targets)
          ? quoteRequest.targets
              .map(
                (target) =>
                  config.role?.find((role) => role.type === target)?.text ||
                  target
              )
              .join(", ")
          : "-";

        csvdata.push([
          quoteRequest.genericTaskId || "-",
          quoteRequest.productName,
          quoteRequest.description,
          quoteRequest.quantity,
          quoteRequest.unit,
          this.getStatusText(quoteRequest.status),
          ConvertDateTime(quoteRequest.createdDate),
          quoteRequest.notes,
        ]);
      });
      this.setState({ data: filteredData, csvdata, loading: false });
    });
  }

  SaveExcel = (data) => {
    const worksheet = XLSX.utils.aoa_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "UreticiTeklifleri.xlsx");
  };

  searchInput;

  render() {
    const state = this.state;
    return (
      <>
        <Table
          pagination={{ defaultPageSize: 10, position: ["bottomRight"] }}
          rowKey={(row) => "key" + row.id}
          size="small"
          style={{ maxWidth: "99.5%" }}
          loading={this.state.loading}
          columns={this.state.columns}
          dataSource={state.data}
        />

        <QuoteModal
          key={`${this.state.isEditMode}-${
            this.state.editQuoteData?.id || "new"
          }`}
          visible={this.state.quoteModalVisible}
          onCancel={() => {
            this.setState({
              quoteModalVisible: false,
              selectedQuoteRequest: null,
              isEditMode: false,
              editQuoteData: null,
            });
          }}
          onSubmit={(formData, editId) => {
            if (this.state.isEditMode) {
              UpdateManufacturerQuote(editId, formData).then((res) => {
                if (res) {
                  this.setState({
                    quoteModalVisible: false,
                    selectedQuoteRequest: null,
                    isEditMode: false,
                    editQuoteData: null,
                  });
                  this.GetQuoteRequests();
                }
              });
            } else {
              CreateManufacturerQuote(formData).then((res) => {
                if (res) {
                  this.setState({
                    quoteModalVisible: false,
                    selectedQuoteRequest: null,
                    isEditMode: false,
                    editQuoteData: null,
                  });
                  this.GetQuoteRequests();
                }
              });
            }
          }}
          quoteRequest={this.state.selectedQuoteRequest}
          isEdit={this.state.isEditMode}
          initialData={this.state.editQuoteData}
        />

        <QuoteDetailsModal
          visible={this.state.quoteDetailsModalVisible}
          onCancel={() => {
            this.setState({
              quoteDetailsModalVisible: false,
              selectedQuoteDetails: null,
            });
          }}
          quoteData={this.state.selectedQuoteDetails}
        />
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.auth.user,
});

export default connect(mapStateToProps)(ProducerQuotesScreen);
